export const CREATION = {
  isFullScreen: true,
  shouldReplacePath: true,
  path: '/stocks/inventories/transfers/create',
  isVisible: () => false,
};

export const DETAILS = {
  isFullScreen: true,
  shouldReplacePath: true,
  path: '/stocks/inventories/transfers/:id/details',
  isVisible: () => false,
};
